import { toggleFilterMenu, uncheckAllCheckboxes } from "./filter-helpers";
import { animateFlavors } from "./flavor-animation";

/**
 * Renders only changed productions
 *
 * @param {Array.<String>} next
 * @param {NodeList} prev
 */
function diffRender(next, prev) {
  const dom = prev.children;
  const parser = new DOMParser();

  if (next.length && dom[0].dataset.empty) {
    dom[0].parentNode.removeChild(dom[0]);
  }

  next.forEach((html, index) => {
    const doc = parser.parseFromString(html, "text/html");
    const item = doc.body.firstChild;

    if (!dom[index]) {
      prev.appendChild(item);
    } else if (
      dom[index].href !== item.href ||
      item.classList.toString() !== dom[index].classList.toString()
    ) {
      prev.children[index].insertAdjacentElement("beforebegin", item);
    }
  });

  let count = dom.length - next.length;
  if (count > 0) {
    for (; count > 0; count -= 1) {
      dom[dom.length - count].parentNode.removeChild(dom[dom.length - count]);
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll("[data-wr-wine-filter]")
    .forEach(async (element) => {
      const result = await fetch("/wp-json/wr/v1/wines");
      const data = await result.json();
      const { wines, filters } = data;
      let sortedWines = [...wines];

      let filterSelections = Object.keys(filters).reduce((acc, key) => {
        acc[key] = [];
        return acc;
      }, {});

      let searchValue = "";

      const filterList = element.querySelector("[data-filter-list]");
      const searchForm = element.querySelector("[data-filter-search]");
      const searchField = searchForm.querySelector("#filter-search-input");
      const filterResult = element.querySelector("[data-filter-result]");
      const blobContainer = element.querySelector("[data-blobs]");

      filterList.innerHTML = Object.entries(filters)
        .map(
          ([filter, { label, items }]) => `
            <li class="Filter-toggle bg-theme text-theme rounded-sm md:w-full mb-0.5" id="filter--${filter}">
            <label class="Filter-selection text-burgundy hover:text-burgundy-light transition-colors duration-300 tracking-[1px] font-medium py-3 flex justify-between items-center cursor-pointer mx-4 group">
            ${label}
            <svg class="Chevron-icon stroke-burgundy group-hover:stroke-burgundy-light transition-colors duration-300" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 5L8 11L14 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            </label>
            <ul class="list-none">
            ${items
              .map(
                ({ name, slug }, i) => `
                <li class="bg-offwhite px-3 pt-2 pb-0 hidden last-of-type:pb-4">
                <label class="text-sm flex items-center gap-2 cursor-pointer pb-2 ${i < items.length - 1 ? "border-b border-cream" : ""}">
                <input type="checkbox" name="${name}" value="${slug}" data-category=${filter}  class="dropdown-checkbox cursor-pointer" />
                ${name}
                </label>
                </li>`
              )
              .join("")}
                </ul>
                </li>
                `
        )
        .join("");

      const filterToggle = element.querySelectorAll(".Filter-toggle");
      const clearFilterButtonMobile = element.querySelector(
        "[data-mobile-clear]"
      );
      const hitContainer = element.querySelector("[data-hit-number]");
      const mobileToggleButton = element.querySelectorAll(
        "[data-result-button]"
      );

      mobileToggleButton.forEach((button) => {
        button.addEventListener("click", () => {
          toggleFilterMenu();
        });
      });

      // Toggle filter sections to show children and change ul-style
      filterToggle.forEach((button) => {
        if (button.children?.length > 1) {
          const toggleButton = button.querySelector(".Filter-selection");
          toggleButton?.addEventListener("click", () => {
            if (button.classList.contains("bg-theme")) {
              button.classList.remove("bg-theme");
              button.classList.add("bg-offwhite");
            } else {
              button.classList.remove("bg-offwhite");
              button.classList.add("bg-theme");
            }
            const children = button.querySelectorAll("li");
            const icon = toggleButton.querySelector(".Chevron-icon");

            toggleButton.classList.toggle("active");
            icon.classList.toggle("active");

            children.forEach((child) => {
              child.classList.toggle("hidden");
            });
          });
        }
      });

      // Render and update filter blobs
      const updateFilterBlobs = () => {
        // To prevent removeAllFiltersButton from showing
        if (Object.values(filterSelections).every((filter) => !filter.length)) {
          blobContainer.innerHTML = "";
        } else {
          const removeAllFiltersButton = [
            `<li class='Clear-filter Clear-filter-btn bg-cream text-burgundy pt-0.5 pb-1 px-3 hidden md:flex'>Rensa filter</li>`,
          ];

          const filterBlobs = Object.keys(filterSelections).flatMap((key) =>
            filterSelections[key].map(
              (filterName) =>
                `<li class='Selected-filter Selected-filter-btn bg-cream text-burgundy pt-0.5 pb-1 px-3 flex'
                  data-category=${key}
                  data-name=${filterName.replace(" ", "-")}>
                ${filterName}
              </li>`
            )
          );

          blobContainer.innerHTML =
            removeAllFiltersButton + filterBlobs.join("");
        }
      };

      // Filter through all wines with checked filters
      const renderSearchResult = () => {
        let filteredSearchResult = [...sortedWines];

        Object.keys(filterSelections).forEach((filterKey) => {
          if (!filterSelections[filterKey].length) {
            return;
          }
          filteredSearchResult = filteredSearchResult.filter((wine) =>
            filterSelections[filterKey].some((k) =>
              wine[filterKey].some((pf) => pf.name === k)
            )
          );
        });
        if (searchValue) {
          filteredSearchResult = filteredSearchResult.filter((wine) => {
            const wineCopy = { ...wine };
            wineCopy.html = "";

            const values = Object.values(wineCopy);
            const searchIn = JSON.stringify(values).toLowerCase();

            if (searchIn.includes(searchValue)) {
              return true;
            }
            return false;
          });
        }

        // Set number of hits on mobile view
        hitContainer.innerHTML =
          filteredSearchResult.length === wines.length
            ? ""
            : `(${filteredSearchResult.length})`;

        if (filteredSearchResult.length) {
          const filterHtml = filteredSearchResult.map((wine) => wine.html);
          // filterResult.innerHTML = filterHtml.join("");
          diffRender(filterHtml, filterResult);
          animateFlavors();
        } else {
          // Message for no results
          filterResult.innerHTML = `<p data-empty="true">Inga produktioner matchade ditt urval</p>`;
        }
        updateFilterBlobs();
      };

      // Search form
      searchForm.addEventListener("submit", (e) => {
        e.preventDefault();
        const formdata = new FormData(e.target);

        searchValue = formdata.get("search-value").toLowerCase() ?? "";
        renderSearchResult();
      });
      const handleSearch = (e) => {
        if (!e.target.value) {
          searchValue = "";
          renderSearchResult();
        } else if (e.target.value.length > 2) {
          searchValue = e.target.value.toLowerCase();
          renderSearchResult();
        }
      };
      searchField.addEventListener("change", handleSearch);
      searchField.addEventListener("search", handleSearch);
      searchField.addEventListener("keyup", handleSearch);

      // Remove filter-blob
      element.addEventListener("click", (e) => {
        const target = e.target.closest(".Selected-filter");
        if (target) {
          // uncheck value in filter list
          const checkboxes = element.querySelectorAll(".dropdown-checkbox");
          checkboxes.forEach((checkbox) => {
            if (checkbox.name.replace(" ", "-") === target.dataset.name) {
              checkbox.checked = false;
            }
          });

          const indexOfObject = filterSelections[
            target.dataset.category
          ].indexOf(target.dataset.name.replace("-", " "));

          // Remove value from filterSelections
          filterSelections[target.dataset.category].splice(indexOfObject, 1);

          clearFilterButtonMobile.classList.add("opacity-50");

          updateFilterBlobs();
          renderSearchResult();
        }
      });

      // Remove all filters
      element.addEventListener("click", (e) => {
        const target = e.target.closest(".Clear-filter");

        if (target) {
          filterSelections = Object.keys(filters).reduce((acc, key) => {
            acc[key] = [];
            return acc;
          }, {});
          clearFilterButtonMobile.classList.add("opacity-50");

          uncheckAllCheckboxes();
          updateFilterBlobs();
          renderSearchResult();
        }
      });

      const sortFunction = (target) => {
        if (target) {
          const sortingValue = target.split("-")[0];
          const sortingDirection = target.split("-")[1];

          if (sortingValue === "price") {
            sortedWines.sort((a, b) => a[sortingValue] - b[sortingValue]);
          } else {
            sortedWines.sort((a, b) =>
              a[sortingValue].localeCompare(b[sortingValue], "sv")
            );
          }
          if (sortingDirection === "desc") {
            sortedWines.reverse();
          }
        } else {
          sortedWines = [...wines];
        }
        renderSearchResult();
      };

      const updateFilterSelections = (target) => {
        if (target.dataset.category) {
          if (target.checked) {
            clearFilterButtonMobile.classList.remove("opacity-50");
            filterSelections[target.dataset.category].push(target.name);
          } else {
            clearFilterButtonMobile.classList.add("opacity-50");
            const indexOfObject = filterSelections[
              target.dataset.category
            ].indexOf(target.name);

            if (indexOfObject !== -1) {
              filterSelections[target.dataset.category].splice(
                indexOfObject,
                1
              );
            }
          }

          renderSearchResult();
        }
      };

      // Register which target was clicked, sorting or filter
      const registerChange = ({ target }) => {
        if (target.hasAttribute("data-sorting-button")) {
          sortFunction(target.value);
        } else {
          updateFilterSelections(target);
        }
      };

      // Catches all changes (checkbox and sorting)
      element.addEventListener("change", registerChange);
    });
});
